import apiFetch from '../apiFetch'

export default function (token, finderParams) {
  return apiFetch({
    endPoint: 'DossierFinder/VehiclesSimpleDownload',
    method: 'POST',
    body: finderParams,
    token: token,
    parseBlobAndAssign: true
  })
}
